import { api } from "@/lib/api-client";

// Dossier lookup client — fetches the tenant's Dossier users and a doc-type's
// field schema via Capture's server-side proxy (which injects the internal key
// + Suite tenant id). Powers the Dossier-export config pickers (F-033 + F-036).

export interface DossierUser {
  id: string;
  name: string | null;
  email: string;
  isSystem: boolean;
  canCreate: boolean;
}

export interface DossierServiceAccount {
  id: string;
  name: string | null;
  sourceLabel: string | null;
  active: boolean;
  canCreate: boolean;
}

export interface DossierDocTypeField {
  key: string;
  label: string;
  type: string;
  required: boolean;
}

export interface DossierDocTypeSchema {
  name: string;
  version: number;
  fields: DossierDocTypeField[];
}

/** List the tenant's Dossier users (for the serviceUserId picker). */
export function listDossierUsers(): Promise<{ users: DossierUser[] }> {
  return api.get<{ users: DossierUser[] }>(`/dossier/users`);
}

/** List the tenant's Dossier service accounts (for the serviceUserId picker). */
export function listServiceAccounts(): Promise<{ serviceAccounts: DossierServiceAccount[] }> {
  return api.get<{ serviceAccounts: DossierServiceAccount[] }>(`/dossier/service-accounts`);
}

/** Fetch a Dossier doc type's field schema by name (for the mapping target picker). */
export function getDossierDocTypeSchema(name: string): Promise<DossierDocTypeSchema> {
  return api.get<DossierDocTypeSchema>(
    `/dossier/doc-type-schema?name=${encodeURIComponent(name)}`,
  );
}
